import React from "react";

import { Editor, ShortcutKey } from "amis-editor";
import { message, notification } from "antd";
import HttpHelper from "../../helper/http-helper";

import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/css/v4-shims.css";
import "amis/lib/themes/cxd.css";
import "amis/lib/helper.css";
import "amis/sdk/iconfont.css";
import "amis-editor-core/lib/style.css";
import "./style.scss";

localStorage.setItem('suda-i18n-locale', 'zh-CN');

export default class TplEditor extends React.PureComponent<{}, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            isPreview: false,
            tplValue: {
                asideResizor: false,
                editorState: 'default',
                pullRefresh: { disabled: true },
                regions: ['body']
            },
            apps: [],
            tplUuid: this.getUuid(),
        };
    }

    private getUuid(): string {
        // @ts-ignore
        const uuid = this.props.match?.params?.uuid || '';
        if (uuid === '') {
            message.error('参数错误');
        } else {
            this.queryTpl(uuid);
        }

        return uuid;
    }

    private queryTpl(uuid: string) {
        HttpHelper.get(`/tpls/${uuid}`).then((res) => {
            console.info(res);
            this.setState({ tplValue: res.data.content });
        }).catch(err => {
            message.warning('获取模板信息错误');
        });
    }

    public onTplChange(tplValue: any) {
        this.setState({ tplValue });
    }

    public save() {
        HttpHelper.put(`/tpls/${this.state.tplUuid}/content`, { content: this.state.tplValue }).then((res) => {
            message.success('保存成功');
        }).catch(err => {
            console.warn(err);
            message.warning(err.message);
        });
    }

    showApi() {
        const arr = [
            ['查询列表：', 'get:/values/#{uuid}'],
            ['新增：', 'post:/values/#{uuid}'],
            ['查询子级列表：', 'get:/values/#{uuid}?pid=${id}'],
            ['新增子级：', 'post:/values/#{uuid}?pid=${id}'],
            ['查询：', 'get:/values/#{uuid}/contents/${id}'],
            ['更新：', 'put:/values/#{uuid}/contents/${id}'],
            ['删除：', 'delete:/values/#{uuid}/contents/${id}'],
            // ['批量删除：', 'delete:/values/#{uuid}/contents/0?id=${ARRAYMAP(selectedItems, a => a.id)}'],
            ['查询首个：', 'get:/values/#{uuid}/first'],
            ['保存首个：', 'put:/values/#{uuid}/first'],
            ['文件上传：', 'post:/uploader/simple'],
        ];

        notification.open({
            message: 'API说明',
            description: (
                <ol className="api-item">
                    {arr.map(a => (
                        <li>{a[0]}<span className="url">{a[1]}</span></li>
                    ))}
                </ol>
            )
        });
    }

    public exit() {
        // this.props.history.push("/");
        console.info('exit');
    }

    public fetch(opt: any): Promise<any> {
        const { method, url, data } = opt;
        const fixedUrl = url.replace("#{uuid}", `${this.state.tplUuid}`);

        return new Promise((resolve, reject) => {
            HttpHelper.request(method, fixedUrl, {}, data, opt.headers || {}).then((msg: any) => {
                if (opt.messages?.success) message.success(opt.messages.success);
                return resolve({ data: msg });
            }).catch((err: any) => {
                console.info(err);
                const msg = err.response?.data || (err.message || opt.messages?.failed || '请求错误');
                message.error(msg);
                return reject({ data: {} });
            });
        });
    }

    render() {
        return (
            <>
                <div className="Editor-Demo">
                    <div className="Editor-header">
                        <div className="Editor-title"></div>

                        <div className="Editor-header-actions">
                            <ShortcutKey />

                            <div
                                className={`header-action-btn m-1 ${this.state.isPreview ? "primary" : ""}`}
                                onClick={() => this.setState({ isPreview: !this.state.isPreview })}
                            >
                                {this.state.isPreview ? "编辑" : "预览"}
                            </div>

                            <div
                                className={`header-action-btn primary`}
                                onClick={() => this.showApi()}
                            >
                                查看API
                            </div>

                            <div
                                className={`header-action-btn primary`}
                                onClick={() => this.save()}
                            >
                                保存模板
                            </div>

                            {!this.state.isPreview && (
                                <div
                                    className={`header-action-btn exit-btn`}
                                    onClick={() => this.exit()}
                                >
                                    退出
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="Editor-inner">
                        <Editor
                            theme={"cxd"}
                            // i18nEnabled={true}
                            appLocale="zh-CN"
                            preview={this.state.isPreview}
                            value={this.state.tplValue}
                            onChange={(e) => this.onTplChange(e)}
                            onPreview={() => { this.setState({ isPreview: true }) }}
                            className="is-fixed"
                            // disablePluginList={this.disablePlugins}
                            showCustomRenderersPanel={true}
                            amisEnv={{
                                // enableAMISDebug: true,
                                fetcher: (opt) => this.fetch(opt),
                                notify: (type, msg, conf) => {
                                    console.info(type);
                                    console.info(msg);
                                    console.info(conf);
                                    switch (type) {
                                        case "success":
                                            // msg &&
                                            // msg != "success" &&
                                            // message.success(msg);
                                            break;
                                        case "error":
                                            // message.error('请求失败');
                                            break;
                                    }
                                },
                            }}
                        />
                    </div>
                </div>
            </>
        );
    }
}
